<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/shangpintiaocan.png" class="jxyd-imgicon"/>
				商品套餐
			</div>
			<button class="jxyd-button jxyd-primary" @click="dataSubmit">保存</button>
			<button class="jxyd-button" @click="emptyForm">重置</button>
		</div>
		<div>
		    <div id="baseInfo">
		        <div class="modal-title">
		            <div class="layout-title-left">
		                <img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon"/>
		                基本信息
		            </div>
		            <div class="layout-title-right">
		            </div>
		        </div>
		
		        <table id="baseinfo-table">
		            <tr>
		                <td class="key">
		                    套餐条码
		                    <font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
		                </td>
		                <td style="width:35%;">
		                    <input v-model="formItem.code" type="text" placeholder="使用扫码枪扫描或手动输入，留空自动生成" class="baseinfo-input" icon="md-qr-scanner" />
		                </td>
		                <td class="key">
		                    套餐名称
		                    <font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
		                </td>
		                <td style="width:35%;">
		                    <input v-model="formItem.name" type="text" placeholder="请输入套餐名称" class="baseinfo-input" />
		                </td>
		            </tr>
		
		            <tr>
		                <td class="key">
		                    折扣(%)
		                    <font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
		                </td>
		                <td style="text-align: left;">
		                    <input type="number" v-model="formItem.discount" placeholder="请输入折扣" class="baseinfo-input" @blur="discountBlur" />
		                </td>
		                <td class="key">
		                    套餐种类
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
		                </td>
		                <td style="text-align: left;">
		                    <selectTree class="package-select" v-model="formItem.type" :border='false' multiple :treeData="packageTypeData"></selectTree>
		                </td>
		            </tr>
					<tr>
						<td class="key">
						    备注
						</td>
						<td style="text-align: left;" colspan="3">
						    <input type="textarea" v-model="formItem.note" placeholder="请输入备注" class="baseinfo-input">
						</td>
					</tr>
		        </table>
		    </div>
		
		    <div class="file">
		        <div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
		            <div class="layout-title-left">
		                <img src="/static/imgs/tupianwenjian.png" class="jxyd-imgicon"/>
		                套餐图片
		            </div>
		            <div class="layout-title-right">
		            </div>
		        </div>
		        <div style="padding:15px 10px;">
		            <Upload :show-upload-list="false"
		                    action="/file/file/UploadImg"
		                    :max-size="2048"
		                    :format="['jpg','jpeg','png','gif']"
		                    :on-format-error="upLoadFormatError"
		                    :on-exceeded-size="uploadFileSizeError"
		                    :before-upload="upLoadBefore"
		                    :on-success="upLoadFileSuccess"
		                    :on-error="upLoadFileError">
		                <Button type="dashed" title="添加图片">
		                    <Icon type="ios-images" size='18'/>
		                    添加图片
		                </Button>
		                <span style="padding-left:20px;">
		                    注：上传文件大小限制为2M；格式支持图片类型文件；最多支持上传3个图片
		                </span>
		            </Upload>
		            <ul class="imgFile">
		                <li v-for="item in formItem.imgFile">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleFile(item.url)"/>
		                    <Avatar id="head-img-ava" shape="square" :src="item.url" style="width:100%;height:100%;" />
		                </li>
		            </ul>
		        </div>
		    </div>
		    <div id="commodityInfo">
		        <div class="modal-title">
		            <div class="layout-title-left">
		                <img src="/static/imgs/shangpin.png" class="jxyd-imgicon"/>
		                商品信息
		            </div>
		            <div class="layout-title-right">
		                <SelectCommodityModal ref="selectCommodityModal" @getResult="initCommodityList" :selectedCommodity="selectedGoods" :isStock="false"></SelectCommodityModal>
		                <Input type="text" v-model="scanCodeId"
		                       placeholder="使用扫码枪或手动输入"
		                       @keydown.enter.native="enterDownTime = new Date().getTime()"
		                       @keyup.enter.native="scanUpFunc"
		                       icon="md-qr-scanner"
		                       style="width:200px;" />
		            </div>
		        </div>
		        <Table stripe :columns="commodityColumn" :data="formItem.commodityPackageDetailInfos"></Table>
		    </div>
			<div id="voucher-bottomBar">
			    <table style="float: left;">
			        <tr>
			            <td style="border-right:1px solid #DCDFE6;padding-right:15px;">
			                <span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">采购合计：</span>
			                <span style="color: #ff4d4d;font-size: 22px;">￥{{formItem.purchaseAmount}}</span>
			            </td>
			            <td style="border-right: 1px solid #DCDFE6; padding-right: 15px; padding-left: 15px;">
			                <span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">销售合计：</span>
			                <span style="color: #ff4d4d;font-size: 22px;">￥{{formItem.salesAmount}}</span>
			            </td>
			            <td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">计量单位：</td>
			            <td>
			                <Select v-model="formItem.unit">
			                    <Option v-for="item in unitOptionList" :value="item.key" :key="item.key">{{ item.key }}</Option>
			                </Select>
			            </td>
			            <td style="padding-right: 15px; border-right: 1px solid #DCDFE6;">
			                <Button @click="unitConfigModal = true;">
			                    <Icon type="ios-settings-outline" size='18'/>
			                </Button>
			            </td>
			            <td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">采购价格：</td>
			            <td style="padding-right: 15px; border-right: 1px solid #DCDFE6;">
			                <InputNumber v-model="formItem.intoPrice" :min="0" placeholder="采购价格"></InputNumber>
			            </td>
			            <td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">销售价格：</td>
			            <td>
			                <InputNumber v-model="formItem.outPrice" :min="0" placeholder="销售价格"></InputNumber>
			            </td>
			        </tr>
			    </table>
			</div>
		</div>
		<Modal v-model="unitConfigModal" draggable sticky scrollable>
		    <p slot="header" style="text-align:left">
		        <Icon type="ios-create-outline" size='18'/>
		        <span> 添加计量方式</span>
		    </p>
		    <div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
		        <table style="width:100%;">
		            <tr>
		                <td style="width:50%;">
		                    <Input v-model="unitFormItem.key" placeholder="请输入显示名" />
		                </td>
		                <td style="width:50%;" colspan="2">
		                    <Input v-model="unitFormItem.value" placeholder="请输入编号" @keyup.enter.native="addUnit()" />
		                </td>
		            </tr>
		            <tr>
		                <td class="tab-hander">显示名</td>
		                <td class="tab-hander">编号</td>
		                <td class="tab-hander" style="text-align:center;">操作</td>
		            </tr>
		            <tr v-for="item in unitOptionList">
		                <td>{{item.key}}</td>
		                <td>{{item.value}}</td>
		                <td style="text-align:center;">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="deleUnit(item.id)"/>
		                </td>
		            </tr>
		        </table>
		
		    </div>
		    <div slot="footer">
		        <Button size="large" type="error" @click="unitConfigModal = false;">关闭</Button>
		        <Button size="large" @click="addUnit()">保存</Button>
		    </div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import selectTree from '@/components/selectTree'
    import SelectCommodityModal from '@/components/SelectCommodityModal'
	export default {
		name: 'packagefunc',
		components: {
			selectTree,
			SelectCommodityModal
		},
		data() {
			return {
				formItem: {
				    id: 0,
				    code: '',
				    name: '',
				    unit: '',
				    type: '',
				    commodityPackageDetailInfos: [],
				    discount: 100,
				    purchaseAmount: 0,
				    salesAmount:0,
				    intoPrice: 0,
				    outPrice: 0,
				    isUse: true,
				    creator: parseInt(localStorage.getItem("userId")),
				    note: '',
				    imgFile: []
				},
                selectedGoods: [],
				commodityColumn: [
				    {
				        title: '操作',
				        key: 'action',
				        width: 80,
				        align: 'center',
				        fixed: 'left',
				        render: (h, params) => {
				            return [h('Icon', {
				                style: {
				                    cursor: 'pointer'
				                },
								props:{
									type:'md-trash',
									size:24
								},
				                on: {
				                    click: (e) => {
				                        this.formItem.commodityPackageDetailInfos.splice(params.index, 1);
				                        this.selectedGoods.splice(params.index, 1);
				                    }
				                }
				            })]
				        }
				    },
					{
					    title: '商品',
					    key: 'name',
				        fixed: 'left',
				        width: 345,
						render:(h,params) => {
							return h('a',{
								class:'jxyd-a',
								on: {
								    click: (e) => {
								        this.$router.push({
								        	path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
								        });
								    }
								}
							},params.row.name);
						}
					},
				    {
				        title: '单位',
				        key: 'unit',
				        width: 130,
				        render: (h, params) => {
				            return [h('Select', {
				                props: {
				                    transfer: true,
				                    value: params.row.unit
				                },
				                on: {
				                    input: (event) => {
				                        this.formItem.commodityPackageDetailInfos[params.index].unit = event;
				                        for (let i = 0; i < this.formItem.commodityPackageDetailInfos[params.index].commodity.extraUnits.length; i++) {
				                            if (this.formItem.commodityPackageDetailInfos[params.index].commodity.extraUnits[i].unit == event) {
				                                this.formItem.commodityPackageDetailInfos[params.index].purchasePrice = this.formItem.commodityPackageDetailInfos[params.index].commodity.extraUnits[i].conversionIntoPrice;
				                                this.formItem.commodityPackageDetailInfos[params.index].salesPrice = this.formItem.commodityPackageDetailInfos[params.index].commodity.extraUnits[i].conversionOutPrice;
				                                this.formItem.commodityPackageDetailInfos[params.index].stock = formatNum(this.formItem.commodityPackageDetailInfos[params.index].commodity.stock * this.formItem.commodityPackageDetailInfos[params.index].commodity.extraUnits[i].conversionRate);
				                                this.formItem.commodityPackageDetailInfos[params.index].quantity = 1;
				                                this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchasePriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].purchasePrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                                this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchaseAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].purchasePriceAfterDiscount));
				                                this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesPriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].salesPrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                                this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].salesPriceAfterDiscount));
				                            }
				                        }
				                    }
				                },
				            },
				                params.row.commodity.extraUnits.map(function (type) {
				                    return h('Option', {
				                        props: {
				                            value: type.unit,
				                            key: type.unit
				                        }
				                    }, type.unit);
				                })
				            )];
				        }
				    },
				    {
				        title: '规格',
				        key: 'format',
				        width: 140,
				    },
				    {
				        title: '当前库存',
				        key: 'stock',
				        width: 140,
				    },
				    {
				        title: '数量',
				        key: 'quantity',
				        width: 130,
				        render: (h, params) => {
				            return [h('InputNumber', {
				                attrs: {
				                    'min': 0,
				                    'value': params.row.quantity
				                },
				                on: {
				                    input: (e) => {
				                        this.formItem.commodityPackageDetailInfos[params.index].quantity = e;
				                        this.$nextTick(function () {
				                            if (e == null) {
				                                this.formItem.commodityPackageDetailInfos[params.index].quantity = 0;
				                            }
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchasePriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].purchasePrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchaseAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].purchasePriceAfterDiscount));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesPriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].salesPrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].salesPriceAfterDiscount));
				                        });
				                    }
				                }
				            })]
				        }
				    },
				    {
				        title: '采购单价',
				        key: 'purchasePrice',
				        width: 140,
				        render: (h, params) => {
				            return [h('InputNumber', {
				                attrs: {
				                    'min': 0,
				                    'value': params.row.purchasePrice
				                },
				                on: {
				                    input: (e) => {
				                        this.formItem.commodityPackageDetailInfos[params.index].purchasePrice = e;
				                        this.$nextTick(function () {
				                            if (e == null) {
				                                this.formItem.commodityPackageDetailInfos[params.index].purchasePrice = 0;
				                            } else if (e < 0) {
				                                this.formItem.commodityPackageDetailInfos[params.index].purchasePrice = 0;
				                            }
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchasePriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].purchasePrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchaseAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].purchasePriceAfterDiscount));
				                        })
				                    }
				                }
				            })]
				        }
				    },
				    {
				        title: '销售单价',
				        key: 'salesPrice',
				        width: 140,
				        render: (h, params) => {
				            return [h('InputNumber', {
				                attrs: {
				                    'min': 0,
				                    'value': params.row.salesPrice
				                },
				                on: {
				                    input: (e) => {
				                        this.formItem.commodityPackageDetailInfos[params.index].salesPrice = e;
				                        this.$nextTick(function () {
				                            if (e == null) {
				                                this.formItem.commodityPackageDetailInfos[params.index].salesPrice = 0;
				                            } else if (e < 0) {
				                                this.formItem.commodityPackageDetailInfos[params.index].salesPrice = 0;
				                            }
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesPriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].salesPrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].salesPriceAfterDiscount));
				                        })
				                    }
				                }
				            })]
				        }
				    },
				    {
				        title: '折扣(%)',
				        key: 'discount',
				        width: 140,
				        render: (h, params) => {
				            return [h('InputNumber', {
				                attrs: {
				                    'min': 0,
				                    'max': 100,
				                    'value': params.row.discount
				                },
				                on: {
				                    input: (e) => {
				                        this.formItem.commodityPackageDetailInfos[params.index].discount = e;
				                        this.$nextTick(function () {
				                            if (e == null) {
				                                this.formItem.commodityPackageDetailInfos[params.index].discount = 100;
				                            } else if (e < 0) {
				                                this.formItem.commodityPackageDetailInfos[params.index].discount = 100;
				                            }
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchasePriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].purchasePrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchaseAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].purchasePriceAfterDiscount));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesPriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].salesPrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
				                            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].salesPriceAfterDiscount));
				                        });
				                    }
				                }
				            })]
				        }
				    },
				    {
				        title: '折后采购单价',
				        key: 'purchasePriceAfterDiscount',
				        width: 140
				    },
				    {
				        title: '折后销售单价',
				        key: 'salesPriceAfterDiscount',
				        width: 140
				    },
				    {
				        title: '采购总金额',
				        key: 'purchaseAmount',
				        width: 200
				    },
				    {
				        title: '销售总金额',
				        key: 'salesAmount',
				        width: 200
				    },
				    {
				        title: '备注',
				        key: 'note',
				        width: 350,
				    }
				],
                scanCodeId: '',
                unitOptionList: [],
                unitConfigModal: false,
                unitFormItem: {
                    id: 0,
                    key: '',
                    value: '',
                    pid: 0,
					pcode:'',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                unitPid: 'spdw',
				commodityPackageTypePid:'sptczl',
				packageTypeData:[]
			}
		},

		methods: {
			dataSubmit() {
			    var validate = this.submitValidate();
			    if (!validate) {
			        return;
			    }
			    let self = this;
			    request.post('/api/CommodityPackage/EditCommodityPackage', self.formItem).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: '保存失败:' + response.errorMsg
			            });
			            return;
			        }
			
			        //清空form规则检查
			        self.emptyForm();
			        self.$Notice.success({
			            title: '正确提示', duration: 3,
			            desc: '保存成功!'
			        });
			    }).catch(function (error) {
			    })
			},
            initCommodityList(data) { //初始化商品列表数据源
				let isExist = false;
                for (var i = 0; i < data.length; i++) {
					isExist = false;
					for(var n = 0; n < this.selectedGoods.length; n++){
						if(data[i].id == this.selectedGoods[n].id){
							isExist = true;
							break;
						}
					}
					if(!isExist){
						//插入商品Id集合
						this.selectedGoods.push(data[i]);
						//插入商品集合
						this.formItem.commodityPackageDetailInfos.push({
						    commodityId: data[i].id,
						    name: data[i].name,
						    unit: data[i].unit,
						    format: data[i].format,
						    quantity: 1,
						    stock: data[i].stock,
						    purchasePrice: data[i].intoPrice,
						    salesPrice: data[i].outPrice,
						    discount: 100,
						    purchasePriceAfterDiscount: data[i].intoPrice,
						    salesPriceAfterDiscount: data[i].outPrice,
						    purchaseAmount: data[i].intoPrice,
						    salesAmount: data[i].outPrice,
						    note: data[i].note,
						    creator: parseInt(localStorage.getItem("userId")),
						    commodity: data[i]
						});
					}
                }
            },
            emptyForm() {
                this.formItem.id = 0;
                this.formItem.code = '';
                this.formItem.name = '';
                this.formItem.type = '';
                this.formItem.commodityPackageDetailInfos = [];
                this.formItem.discount = 100;
                this.formItem.purchaseAmount = 0;
                this.formItem.salesAmount = 0;
                this.formItem.isUse = true;
                this.formItem.creator = parseInt(localStorage.getItem("userId"));
                this.formItem.note = '';
                this.formItem.imgFile = [];
            },
			submitValidate() {
			    if (!this.formItem.name) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: "套餐名称不可为空"
			        });
			        return false;
			    }
			
			    if (!this.formItem.discount) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: "套餐折扣不可为空"
			        });
			        return false;
			    }
			
			    if (!this.formItem.type) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: "请选择套餐种类"
			        });
			        return false;
			    }
			
			    return true;
			},
			getNextCode() {
			    let self = this;
			    request.get('/api/CommodityPackage/GetNextCode', {
			        params: {
			            prefix: 'SPTC'
			        }
			    }).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: "获取数据失败：" + response.errorMsg
			            });
			            return;
			        }
			
			        self.formItem.code = response.data;
			    }).catch(function (error) {
			    })
			},
			upLoadBefore(file) {
			    if (this.formItem.imgFile.length >= 3) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: '最多上传3个文件!'
			        });
			        return false;
			    }
			},
			upLoadFileSuccess(response, file, fileList) {
			    if (response.state == 0) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: '上传失败：' + response.errorMsg + '!'
			        });
			        return;
			    }
			    this.formItem.imgFile.push({
			        name: this.formItem.name,
			        url: response.data[0],
			        creator: parseInt(localStorage.getItem("userId"))
			    });
			},
			upLoadFileError(error, file, fileList) {
			    this.$Notice.error({
			        title: '错误提示', duration: 3,
			        desc: '上传失败：' + error + '!'
			    });
			},
			upLoadFormatError(file) {
			    this.$Notice.error({
			        title: '错误提示',
			        duration: 3,
			        desc: '上传失败：请上传jpg、jpeg、png、gif格式图片！'
			    });
			},
			uploadFileSizeError(file) {
			    this.$Notice.error({
			        title: '错误提示', duration: 3,
			        desc: '上传失败：不可选择超过2M大小文件！'
			    });
			},
			deleFile(url) {
			    for (var i = 0; i < this.formItem.imgFile.length; i++) {
			        if (this.formItem.imgFile[i].url == url) {
			            this.formItem.imgFile.splice(i, 1);
			        }
			    }
			},
			scanUpFunc() {
			    this.enterUpTime = new Date().getTime();
			    if (this.enterUpTime - this.enterDownTime < 30) {
			        this.addCommodityByCode(this.scanCodeId);
			    } else {
			        this.$refs.selectCommodityModal.searchItems.searchVal = this.scanCodeId;
			        this.$refs.selectCommodityModal.openSelectCommodityModal();
			        this.scanCodeId = '';
			    }
			},
			addCommodityByCode(code) {
			    this.scanCodeId = '';
			    for (var i = 0; i < this.formItem.commodityPackageDetailInfos.length; i++) {
			        if (this.formItem.commodityPackageDetailInfos[i].commodity.code == code) {
			            this.formItem.commodityPackageDetailInfos[i].quantity++;
			            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchasePriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].purchasePrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
			            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `purchaseAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].purchasePriceAfterDiscount));
			            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesPriceAfterDiscount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].salesPrice * (this.formItem.commodityPackageDetailInfos[params.index].discount / 100)));
			            this.$set(this.formItem.commodityPackageDetailInfos[params.index], `salesAmount`, formatNum(this.formItem.commodityPackageDetailInfos[params.index].quantity * this.formItem.commodityPackageDetailInfos[params.index].salesPriceAfterDiscount));
			            return;
			        }
			    }
			    let self = this;
			    request.get('/api/Commodity/GetCommodityByCode', {
			        params: {
			            code: code
			        }
			    }).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: "扫条码获取商品失败：" + response.errorMsg
			            });
			            return;
			        }
			
			        self.initCommodityList([response.data]);
			    }).catch(function (error) {
			    })
			},
			addUnit() {
			    if (!this.unitFormItem.key) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: '显示名不可为空!'
			        });
			        return;
			    }
			    if (!this.unitFormItem.value) {
			        this.$Notice.error({
			            title: '错误提示', duration: 3,
			            desc: '编号不可为空!'
			        });
			        return;
			    }
			    this.unitFormItem.pcode = this.unitPid;
			    let self = this;
			    request.post('/api/DataDictionary/AddDataDictionary', this.unitFormItem).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: '保存失败:' + response.errorMsg
			            });
			            return;
			        }
			
			        self.initUnitOptionList();
			        self.unitFormItem.key = '';
			        self.unitFormItem.value = '';
			        self.$Notice.success({
			            title: '正确提示', duration: 3,
			            desc: '保存成功!'
			        });
			
			    }).catch(function (error) {
			    })
			},
			deleUnit(id) {
			    var self = this;
			    request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: response.errorMsg
			            });
			            return;
			        }
			        self.initUnitOptionList();
			        self.$Notice.success({
			            title: '正确提示', duration: 3,
			            desc: '删除成功!'
			        });
			    }).catch(function (error) {
			    })
			},
			initUnitOptionList(isTrue) {
			    let self = this;
			    //获取收付款账户数据字典
			    request.get('/api/DataDictionary/GetDataDictionaryList', {
			        params: {
			            code: this.unitPid
			        }
			    }).then(function (response) {
			        if (response.state == 0) {
			            self.$Notice.error({
			                title: '错误提示', duration: 3,
			                desc: "获取收付款账户数据失败：" + response.errorMsg
			            });
			            return;
			        }
			        self.unitOptionList = response.data;
			        if (isTrue) {
			            self.formItem.unit = response.data[0].key;
			        }
			    }).catch(function (error) {
			    })
			},
			countAmount(arr) {
			    if (!this.formItem.discount || this.formItem.discount < 1 || this.formItem.discount > 100) {
			        this.formItem.discount = 100;
			    }
			    this.formItem.purchaseAmount = 0;
			    this.formItem.salesAmount = 0;
			    for (let i = 0; i < arr.length; i++) {
			        this.formItem.purchaseAmount += arr[i].purchaseAmount;
			        this.formItem.salesAmount += arr[i].salesAmount;
			    }
			    this.formItem.purchaseAmount = formatNum(this.formItem.purchaseAmount * (this.formItem.discount / 100));
			    this.formItem.salesAmount = formatNum(this.formItem.salesAmount * (this.formItem.discount / 100));
			    if (this.formItem.id <= 0) {
			        this.formItem.intoPrice = this.formItem.purchaseAmount;
			        this.formItem.outPrice = this.formItem.salesAmount;
			    }
			},
			discountBlur() {
			    this.countAmount(this.formItem.commodityPackageDetailInfos);
			},
			initPackageTypeData() {
                let self = this;
                request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
                    params: {
                        code: self.commodityPackageTypePid
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',
                            duration: 3,
                            desc: "获取导航树数据失败：" + response.errorMsg
                        });
                        return;
                    }
					self.packageTypeData = [];
                    self.formatTypeData(self.packageTypeData,response.data);
                }).catch(function (error) {
                })
            },
			formatTypeData(dataArray,array) {
				for (var i = 0; i < array.length; i++) {
					dataArray.push({
						id : array[i].id,
						title : array[i].title,
						value : array[i].title,
						expand : array[i].expand,
						selected:array[i].selected,
						note : array[i].note,
						path : array[i].path,
						children : []
					});
					if(array[i].children && array[i].children.length>0){
						this.formatTypeData(dataArray[i].children,array[i].children);
					}
				}
			},
			async auditPackage(packageId) {
				let self = this;
				return await request.get('/api/CommodityPackage/GetCommodityPackage', {
					params: {
						id: packageId
					}
				});
			},
			assignDetailInfo(data) {
				this.formItem = data;
				this.selectedGoods = [];
				for (var i = 0; i < data.commodityPackageDetailInfos.length; i++) {
					this.selectedGoods.push(data.commodityPackageDetailInfos[i].commodity);
				}
			}
		},
		watch: {
			'formItem.commodityPackageDetailInfos': {
			    deep: true,
			    handler(arr) {
			        this.countAmount(arr);
			    }
			}
		},
		created: function() {
			this.initUnitOptionList(true);
			this.emptyForm();
		},
		async activated() {
			if (this.$route.query.packageId) {
				let response = await this.auditPackage(this.$route.query.packageId);
				if (response.state == 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取商品数据失败：" + response.errorMsg
					});
				} else {
					this.assignDetailInfo(response.data);
				}
			}
			this.initPackageTypeData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.field-table {
		width: 100%;
		padding: 20px 20px 0px 20px;
		border-radius: 5px;
	}

	.field-group {
		background-color: #fff;
		margin-top: 10px;
		overflow: auto;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-right: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	
	#baseInfo {
	    background-color: #fff;
	    border-radius: 5px;
	    padding: 10px 10px;
	}
	
	#baseinfo-table {
	    width: 100%;
	    background-color: #fff;
	    color: #666;
	    border-collapse: collapse;
	}
	
	    #baseinfo-table td, #baseinfo-table th {
	        position: relative;
	        padding: 9px 15px;
	        min-height: 20px;
	        line-height: 20px;
	        font-size: 14px;
	        border-width: 1px;
	        border-style: solid;
	        border-color: #e6e6e6;
	    }
	
	
	.baseinfo-input {
	    border: none;
	    outline: none;
	    height: 15px;
	    padding-left: 0px;
	    width: 100%;
	}
	
	.file {
	    margin-top: 10px;
	    background-color: #fff;
	    border-radius: 5px;
	    padding: 10px 10px;
	}
	
	#commodityInfo {
	    margin-top: 10px;
	    background-color: #fff;
	    border-radius: 5px;
	    padding: 10px 10px;
	}
	
	#voucher-bottomBar {
	    background-color: antiquewhite;
	    padding: 7.5px 22px 0px 10px;
	    box-shadow: 0 -1px 6pxrgba(0,0,0,.15);
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    height: auto !important;
	    padding: 12px 30px !important;
	}
	
	.ivu-select-selection{
	    border: none !important;
	}
	
	.package-select{
	}
	
	
	.imgFile {
		margin-top: 15px;
		overflow: hidden;
	}
	
	.imgFile li {
		margin-right: 15px;
		width: 100px;
		height: 100px;
		float: left;
		position: relative;
	}
	
	.icon-item-dele {
		position: absolute;
		right: 0px;
		top: 0px;
		z-index: 1;
	}
	
	.icon-item-dele:hover {
		transform: scale(1.3);
	}
	
	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}
	
	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.layout-title-right {
		float: right;
	}
	
</style>